import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import type Branch from 'types/branch'
import { mergeURL } from './lib'
import {
  BranchFormPayload,
  EmploymentContractSettingFormPayload,
} from 'types/branch'
import { serialize } from 'object-to-formdata'

const resource = 'branches'

export const requests = {
  fetchMe: () => {
    return axiosForGigbaseBiz.get<DataResponse<Branch>>(
      mergeURL(resource, 'me'),
    )
  },
  update: (params: BranchFormPayload) => {
    return axiosForGigbaseBiz.patch<DataResponse<Branch>>(
      resource,
      serialize(params),
    )
  },
  updateEmploymentContractSetting: (
    params: EmploymentContractSettingFormPayload,
  ) => {
    return axiosForGigbaseBiz.patch<DataResponse<Branch>>(
      mergeURL(resource, 'update_employment_contract_setting'),
      params,
    )
  },
}
